import { getAnalytics, logEvent, setUserId } from "firebase/analytics";
import { getFromStorage } from "./storage";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../constants/firebaseConfig";
import { getPerformance } from "firebase/performance";

const allowAnalytics = process.env.REACT_APP_ALLOW_ANALYTICS === 'true';

let app
let analytics;

if(allowAnalytics){
  // Initialize Firebase
  app = initializeApp(firebaseConfig);
  // Initialize Analytics and get a reference to the service
  analytics = getAnalytics(app);
}


export const setAnalitycsCurrentUser = () => {
  const data = getFromStorage('user');
  const user = data?.email;

  if(user && allowAnalytics){
    setUserId(analytics,user);
  }
}

export const trackCandidateView = (name,hash) => {
  if(allowAnalytics){
    logEvent(analytics, 'candidate_view',{
      hash,
      name
    });
  }
}

export const startGetPerformance = () => {
  if(!allowAnalytics) return;
  const perf = getPerformance(app);
  return perf;
}
